import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import App from './App.vue'
import router from './router'
import store from './store'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'
import './assets/css/tailwind.css'

// Import solid icons from FA
import { faHome, faChevronUp, faAngleDoubleDown, faUsers, faUserPlus, faDna, faPhone, faVial, faFileMedical, faCheckSquare, faUserMd, faHandPointer, faFax, faGlobe, faInfo, faFilePdf, faThumbsUp, faExternalLinkAlt, faBullseye } from '@fortawesome/free-solid-svg-icons'
// Import regular icons fronm FA
import { faCircle } from '@fortawesome/free-regular-svg-icons'
library.add(faCircle, faHome, faChevronUp, faAngleDoubleDown, faUsers, faUserPlus, faDna, faPhone, faVial, faFileMedical, faCheckSquare, faUserMd, faHandPointer, faFax, faGlobe, faInfo, faFilePdf, faThumbsUp, faExternalLinkAlt, faBullseye)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)

Vue.config.productionTip = false

Vue.use(VueAnalytics, {
	id: 'UA-172738792-1',
	router
})

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
